import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative flex h-full w-full flex-col',
    wrapper: 'relative z-2 mx-auto -mt-3 flex flex-1 flex-col',
    imageWrapper: 'h-[295px] w-[295px]',
    image: 'mx-auto block object-contain',
    labels: 'absolute top-5 left-5 z-10 flex flex-col gap-[1px]',
    labelRow: 'flex flex-wrap gap-1',
    label:
      'h-6 w-fit rounded-full px-2.5 py-1 pt-[5px] text-sm leading-[1.2] tracking-[0.06em] text-white uppercase max-lg:mb-1',
    heading: 'text-base leading-[1.5] font-medium max-md:pt-1',
    content: 'flex flex-1 flex-col',
    text: 'line-clamp-4 min-h-[74px] text-sm leading-[1.36] font-light',
    list: 'flex min-h-[128px] flex-col gap-4 md:min-h-[108px] lg:gap-2.5',
    listItem: 'flex gap-2 text-sm leading-[1.36] font-light',
    listItemIcon: 'mt-[2px]',
    listItemDot: 'mt-[6px] h-1 w-1 shrink-0 rounded-full bg-black',
    action: 'mt-auto flex items-center justify-between pt-4',
    priceWrapper: 'flex items-baseline gap-2',
    price: 'flex items-baseline gap-1',
    priceValue:
      'font-(family-name:--font-gotham) text-[22px] leading-[1.5] font-medium',
    priceCurrency:
      'font-(family-name:--font-rf-tone) text-[22px] leading-[1.5]',
    priceOld: 'text-secondary-hover text-base leading-[1.5] line-through',
    button: 'cursor-pointer hover:opacity-70'
  },
  variants: {
    variant: {
      default: {
        base: 'w-[232px] min-w-[232px] lg:w-[295px] lg:min-w-[295px]',
        content: '',
        wrapper: 'max-w-[86%] gap-2 lg:gap-4'
      },
      secondary: {
        base: 'w-[295px]',
        content: 'gap-1 md:gap-2',
        wrapper: 'max-w-[255px] lg:max-w-[252px]',
        heading: 'mt-[13px] mb-1 md:mt-4'
      }
    }
  },
  defaultVariants: {
    variant: 'default'
  }
});
